export const GET_TASK_LIST_REQUEST = 'Request task list';
export const GET_TASK_LIST_SUCCESS = 'Request task list success';
export const GET_TASK_LIST_FAILURE = 'Request task list fail';

export const SET_MISSION_LIST_CURRENT = 'set mission list current';


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/actionType.js